import React, { useState } from "react";
import { ISupplierSelectProps } from "./interface";
import { IOptionProps } from "@atoms/ZSelect/interface";
import { SupplierRequest } from "@/Contracts";
import { searchSupplier } from "@/Services/Settings";
import { ZDynamicSelect } from "@molecules";

const ZSupplierSelect = (props: ISupplierSelectProps) => {
	const { defaultOptions, limit, ...rest } = props;

	const [suppliers, setSuppliers] = useState<IOptionProps[]>([]);

	const formattedDefaultOptions =
		defaultOptions
			?.map(currOption =>
				currOption.name && currOption.id
					? {
							name: currOption.name,
							value: currOption.id
					  }
					: undefined
			)
			.filter(Boolean) ?? [];

	const searchSuppliers = async (value?: string) => {
		try {
			const supplierRequest: SupplierRequest = {
				limit: limit ?? 50,
				keywords: value ?? null,
				selected_id: rest.value ?? null
			};

			const response = await searchSupplier(supplierRequest);
			const options: IOptionProps[] = response.data.map(option => ({
				name: option.name,
				value: option.id
			}));

			setSuppliers(options);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<ZDynamicSelect
			id="supplier_name"
			defaultOptions={formattedDefaultOptions as IOptionProps[]}
			fetchData={searchSuppliers}
			options={suppliers}
			{...rest}
		/>
	);
};

export default React.memo(ZSupplierSelect);
